import Guid from "_shared/guids/guid";
import UnavailableDocumentSchema, { UnavailableDocumentJSON, UnavailableDocumentParams } from "documents/unavailable-documents/_schema/unavailable-document-schema";
import { DocumentUploadFailureCode } from "documents/_api/document-upload-validation";

export default class UnavailableDocument {
  public static create(values: UnavailableDocumentParams): UnavailableDocument {
    const parsed = UnavailableDocumentSchema.validateJSON(values);
    return new UnavailableDocument(parsed);
  }

  public static fromJSON(value: UnavailableDocumentJSON): UnavailableDocument {
    const parsed = UnavailableDocumentSchema.deserialize(value);
    return new UnavailableDocument(parsed);
  }

  public readonly id: Guid;
  public readonly issue: string;
  public readonly status?: "refused";
  public readonly code?: DocumentUploadFailureCode;

  private constructor(values: UnavailableDocumentParams) {
    this.id = values.id;
    this.issue = values.issue;
    this.status = values.status;
    this.code = values.code;
  }

  public toJSON(): UnavailableDocumentJSON {
    return UnavailableDocumentSchema.serialize(this);
  }

  public isEqualTo(other: UnavailableDocument): boolean {
    return this.id.isEqualTo(other.id) && this.issue === other.issue && this.code === other.code;
  }

  public toString(): string {
    return `UnavailableDocument { id: ${this.id.value}, issue: ${this.issue} }`;
  }
}
